// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__nH9Jx","photoBlock":"Message_photoBlock__51RH-"};